import baseApi from "@/api/baseApi";

const api = {
  async update(contact) {
    const response = await baseApi.put("/contact/update", contact);
    return response.data;
  },

  async searchContactPersons(projectId, text, contactPersonId, contactId) {
    let url = `/contact/contactperson/search`;
    if (contactPersonId) {
      url += `?contactPersonId=${contactPersonId}`;

      if (contactId) {
        url += `&contactId=${contactId}`;
      }
    } else if (projectId) {
      url += `?projectId=${projectId}&text=${text}`;
    } else {
      url += `?text=${text}`;
    }

    const response = await baseApi({
      method: "get",
      url: url,
      data: { hideLoader: true },
    });

    return response.data;
  },

  async getCurrentProjects() {
    const response = await baseApi({
      method: "get",
      url: "/contact/contactperson/currentprojects",
      data: { hideLoader: true },
    });

    return response.data;
  },
  async getContactpersons(contactId) {
    const response = await baseApi({
      method: "get",
      url: `/contact/${contactId}/contactpersons`,
      data: { hideLoader: true },
    });

    return response.data;
  },

  async deactivateContactPerson(contactId, contactPersonId) {
    const response = await baseApi({
      method: "put",
      url: `/contact/${contactId}/deactivate/contactPerson/${contactPersonId}`,
    });

    return response.data;
  },

  async activateContactPerson(contactId, contactPersonId) {
    const response = await baseApi({
      method: "put",
      url: `/contact/${contactId}/activate/contactPerson/${contactPersonId}`,
    });

    return response.data;
  },

  async getDeactivatedContactPersons(contactId) {
    const response = await baseApi({
      method: "get",
      url: `/contact/${contactId}/deactivated`,
    });

    return response.data;
  },
};

export default api;
